// The shell's one-shot probe of the tenant feature `ceremony` (#163 AI19,
// src/core/ceremonyFeature.ts): the cheapest ceremony root, one season.
import { graphql } from 'src/graphql'

export const CeremonyFeatureProbeDocument = graphql(/* GraphQL */ `
  query CeremonyFeatureProbe {
    ceremonySeasons(limit: 1) {
      id
    }
  }
`)
